import { Link, createFileRoute } from '@tanstack/react-router'
import { MeetingTypesTable } from '../-components/MeetingTypesTable'
import { MeetingTypeNotesDialog } from '../-components/MeetingTypeNotesDialog'
import { PageTitle } from '@/components/PageTitle'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { requirePermission } from '@/lib/permissions/route-guards'
import { BACKOFFICE_PERMISSION_KEYS } from '@/lib/permissions/backoffice-permissions'

export const Route = createFileRoute(
  '/_app/backoffice/journey-scheduling/meeting-types/',
)({
  component: RouteComponent,
  beforeLoad: requirePermission(BACKOFFICE_PERMISSION_KEYS.journeyScheduling),
})

function RouteComponent() {
  return (
    <div className="min-w-0 space-y-4 py-4">
      <PageTitle title="Meeting Types" />

      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/backoffice">Backoffice</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/backoffice/journey-scheduling">
                Journey Scheduling
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Meeting Types</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
            Meeting Types
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Meeting names, teams, Sales / Service and definitions, organized by
            experience.
          </p>
        </div>
        <MeetingTypeNotesDialog />
      </div>

      <MeetingTypesTable />
    </div>
  )
}
